module.exports = __webpack_public_path__ + "static/quiltedsheepmain-a7b8e1fa0535e8b6a439003642f52751.jpeg";